import React, { useState, useEffect } from 'react';
import '../CSS/Venue.css';
import Header from './Header';
import Footer from './Footer';
import bgImage from '../assets/bgImage.png';
import { FaUsers, FaParking, FaWifi, FaUtensils, FaMusic, FaCamera } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Contactbar from '../Components/ContactBar';
import Layout from '../Components/Layout';
import venue1 from '../assets/LIBRA EVENTS/KSH_2562.jpg';
import venue2 from '../assets/LIBRA EVENTS/KSH_7690.jpg';
import venue3 from '../assets/LIBRA EVENTS/_DSC9636.jpg';
const venues = [
  {
    id: 1,
    name: 'LIBRA BANQUET HALL',
    capacity: '500 Guests',
    price: '₹50,000',
    image: venue1,
    features: [
      { icon: <FaUsers />, text: '1000 Guest Capacity' },
      { icon: <FaParking />, text: 'Free Parking' },
      { icon: <FaWifi />, text: 'High-Speed WiFi' },
      { icon: <FaUtensils />, text: 'Standard Menu' },
      { icon: <FaMusic />, text: 'Sound System' },
      { icon: <FaCamera />, text: 'Photo Zones' }
    ],
    description: `Experience unparalleled luxury at LIBRA BANQUET HALL – your destination for grand celebrations.`
  },
  {
    id: 2,
    name: 'EVA BANQUET HALL',
    capacity: '300 Guests',
    price: '₹35,000',
    image: venue2,
    features: [
      { icon: <FaUsers />, text: '1000 Guest Capacity' },
      { icon: <FaParking />, text: 'Free Parking' },
      { icon: <FaWifi />, text: 'WiFi Available' },
      { icon: <FaUtensils />, text: 'Standard Menu' },
      { icon: <FaMusic />, text: 'Sound System' },
      { icon: <FaCamera />, text: 'Photo Booth' }
    ],
    description: `Celebrate elegance at EVA BANQUET HALL – a refined venue designed for memorable moments.`
  },
  {
    id: 3,
    name: 'KB Patel Party Plot',
    capacity: '200 Guests',
    price: '₹25,000',
    image: venue3,
    features: [
      { icon: <FaUsers />, text: '1000 Guest Capacity' },
      { icon: <FaParking />, text: 'Free Parking' },
      { icon: <FaWifi />, text: 'WiFi Available' },
      { icon: <FaUtensils />, text: 'Standard Menu' },
      { icon: <FaMusic />, text: 'Sound System' },
      { icon: <FaCamera />, text: 'Photo Spots' }
    ],
    description: `Host your grand celebrations in the open-air elegance of KB PATEL PARTY PLOT.`
  }
];
 
const Venue = () => {

    useEffect(() => {
    window.scrollTo(0, 0); // 👈 Scroll to top on page load
  }, []);

  const [selectedVenue, setSelectedVenue] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
 
  const handleSubmit = (e) => {
    e.preventDefault();
 
    const message = `*Venue Booking Request*\n\n*Name:* ${formData.name}\n*Email:* ${formData.email}\n*Phone:* ${formData.phone}\n*Message:* ${formData.message}`;
 
    const phoneNumber = '919909254684'; // 🔁 Replace with your WhatsApp number (with country code)
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
 
    window.open(url, '_blank');
 
    setShowModal(false); // Close modal
    setFormData({ name: '', email: '', phone: '', message: '' }); // Reset form
  };
 
  return (
    <>
      <Header />
     
      {/* Hero Section */}
      <section
        className="about-section"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="overlay container">
          <p className="section-subtitle">ALL YOU NEED TO KNOW</p>
 
          <h1 className="section-title">
            <span className="highlight">LIBRA</span> EVENTS
          </h1>
 
          <div className="breadcrumbs mt-3">
          <a href='/' className="home-link">
            <span className="home">Home</span>
          </a>
 
            <span className="divider"> | </span>
            <span className="about">Venues</span>
          </div>
        </div>
      </section>
 
      {/* Venue Selection Section */}
      <section className="venue-selection">
      <h2 className="venue-heading">Our Venues</h2>
        <div className="venue-grid">
          {venues.map((venue) => (
            <div
              key={venue.id}
              className={`venue-card ${selectedVenue === venue.id ? 'selected' : ''}`}
              onClick={() => setSelectedVenue(venue.id)}
            >
             <div className="venue-image-container">
              <img src={venue.image} alt={venue.name} className="venue-image" />
              <div className="venue-overlay"></div> {/* Add this */}
              <div className="venue-text-overlay">
                <h3>{venue.name}</h3>
                <p>{venue.description}</p>
              </div>
            </div>
 
              <div className="venue-details">
                <div className="venue-features">
                  {venue.features.map((feature, index) => (
                    <div key={index} className="feature-item">
                      <span className="feature-icon">{feature.icon}</span>
                      <span className="feature-text">{feature.text}</span>
                    </div>
                  ))}
                </div>
                <div className="venue-hr"></div>
                <div className="venue-buttons">
                  <Link to={
                    venue.id === 1 ? '/LibraBanquetHall' :
                    venue.id === 2 ? '/EvaBanquetHall' :
                    '/KBPatelPARTYPLOT'
                  }>
                    <button className="venue-know-more-btn">Know More</button>
                  </Link>
                  <button className="venue-book-btn" onClick={() => setShowModal(true)}>Book Now</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
 
      {/* Modal Section */}
      {showModal && (
  <div className="modal-overlay" onClick={() => setShowModal(false)}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <h3>Book Now</h3>
      <form className="modal-form" onSubmit={(e) => handleSubmit(e)}>
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
        />
        <input
          type="tel"
          placeholder="Your Phone"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          required
        />
        <textarea
          placeholder="Message / Special Requests"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        ></textarea>
        <div className="modal-actions">
          <button type="submit" className="submit-btn">Send</button>
          <button type="button" className="close-btn" onClick={() => setShowModal(false)}>Close</button>
        </div>
      </form>
    </div>
  </div>
)}


      <Layout />

              <div className="map-area">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.1513113692577!2d73.1877681!3d22.272257399999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc572a56acfcd%3A0x27bab60c571357df!2sLibra%20Events%20%26%20Decorators!5e0!3m2!1sen!2sin!4v1755148852772!5m2!1sen!2sin"width="100%"
                height="300"
                allowFullScreen=""
                loading="lazy"
                title="Google Map Location"></iframe>
              </div>
      {/* Venue Comparison Section */}



     <Contactbar/>
      <Footer />
    </>
  );
};
 
export default Venue;